export default __webpack_public_path__ + "static/media/api.a5a70eda.svg";